export const useUtils = () => {
  const redirect = (url) => {
    window.location.href = url;
  };

  return { redirect };
};
